module.exports = __webpack_public_path__ + "img/shrugItOff.109cf6a6.png";